import axios from 'axios';
import appConfig from '../config/appConfig';

const axiosInstance = axios.create({
  baseURL: appConfig.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

const authApiClient = axios.create({
  baseURL: `${appConfig.apiBaseUrl}/auth`,
});

// Add a request interceptor to include the token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('AUTH_TOKEN');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Attach token
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export { axiosInstance, authApiClient };
